<template>
    <div class="rating-bar">
        <span v-for="n in maxRating" :key="n" class="star">
            {{ n <= rating ? "★" : "☆" }}
        </span>
    </div>
</template>

<script>
export default {
    name: "RatingBar",
    props: {
        /**
         * The current rating value (integer).
         * Will display that many filled stars.
         */
        rating: {
            type: Number,
            required: true,
            default: 0,
        },
        /** Total number of stars to show */
        maxRating: {
            type: Number,
            default: 5,
        },
    },
};
</script>

<style scoped>
.rating-bar {
    display: inline-flex;
    align-items: center;
    font-size: 1.5rem; /* adjust size */
    color: #ffd700; /* star color */
}
.star {
    margin-right: 0.1em; /* small spacing */
    user-select: none; /* prevent text selection */
}
/* remove extra space on last star */
.star:last-child {
    margin-right: 0;
}
</style>
